import React from "react";
import PaginationLib from "react-js-pagination";

const Pagination = props => (
  <PaginationLib
    innerClass="pagination m-0"
    itemClass="page-item"
    linkClass="page-link"
    pageRangeDisplayed={5}
    {...props}
  />
);

export default Pagination;
